import { render, staticRenderFns } from "./FunctionCfg.vue?vue&type=template&id=5dba5b19&scoped=true"
import script from "./FunctionCfg.vue?vue&type=script&lang=js"
export * from "./FunctionCfg.vue?vue&type=script&lang=js"
import style0 from "./FunctionCfg.vue?vue&type=style&index=0&id=5dba5b19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba5b19",
  null
  
)

export default component.exports